import { render, staticRenderFns } from "./DealStepProgress.vue?vue&type=template&id=fe5c5b3e&"
import script from "./DealStepProgress.vue?vue&type=script&lang=ts&"
export * from "./DealStepProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports